import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { submit, reset } from 'redux-form/immutable';

import Button from '@material-ui/core/Button';
import Step from '@material-ui/core/Step';
import Stepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';

import ReduxDialog from '../../Common/ReduxDialog/index';
import { showDialog, hideDialog, showWarning } from '../../../redux/actions/dialogs';
import Page1 from './Page1';
import Page2 from './Page2';
import Page3 from './Page3';

import { saveJobFormHandler } from '../../../redux/routines';
import { CREATE_JOB_DIALOG } from '../../../redux/constants/dialogs';
import { toJS } from '../../../utils/helper';

import styles from './styles';

// const isAfterOrEqualStart = (value, values) => {
//   console.log('furueInc', value, values);
//   const result = moment(value).startOf('d').isSameOrAfter(moment(values.get('start')).startOf('d'));
//   console.log('isAfterOrEqualStart', result);
//   return result ? undefined : 'End date must be after start date';
// };

class CreateJobDialog extends React.Component {
  state = {
    finished: false,
    stepIndex: 0,
  };

  handleNext = () => {
    const { stepIndex } = this.state;
    if (stepIndex >= 2) {
      this.props.submit(CREATE_JOB_DIALOG);
    } else {
      this.setState({
        stepIndex: stepIndex + 1,
      });
    }
  };

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({ stepIndex: stepIndex - 1 });
    }
  };

  // handleSelectTaskProfiles = (taskProfiles) => {
  //   console.log('handleSelectTaskProfiles', taskProfiles);
  //   this.props.setTaskProfiles(this.props.job, taskProfiles);
  // };
  //
  // handlePreferredItemsChanged = (preferredItems) => {
  //   console.log('handlePreferredItemsChanged', preferredItems);
  //   this.props.setPreferredItems(this.props.job, preferredItems);
  // };

  // renderTaskProfiles() {
  //   return (
  //     <TaskProfileDrilldown
  //       taskProfiles={this.props.job.taskProfiles}
  //       onChange={this.handleSelectTaskProfiles}
  //       selectable
  //     />);
  // }

  // renderPreferredItems() {
  //   return <PreferredItems items={this.props.job.preferredItems} onChange={this.handlePreferredItemsChanged}/>;
  // }

  getStepContent(stepIndex) {
    switch (stepIndex) {
      case 0:
        return <Page1 onSubmit={this.handleNext}/>;
      case 1:
        return <Page2 onSubmit={this.handleNext}/>;
      case 2:
        return <Page3
          onSubmit={saveJobFormHandler}
        />;
      default:
        return 'Invalid step';
    }
  }

  render() {
    const { hideDialog } = this.props;
    const { stepIndex } = this.state;

    const actions = [
      <Button
        key="cancel"
        variant="text"
        color="primary"
        onClick={() => hideDialog(CREATE_JOB_DIALOG)}
      >Cancel</Button>,
      <Button
        key="previous"
        variant="text"
        color="primary"
        disabled={stepIndex === 0}
        onClick={this.handlePrev}
      >Previous</Button>,
      <Button
        key="next"
        variant="contained"
        color="primary"
        autoFocus
        onClick={this.handleNext}
      >{stepIndex === 2 ? 'Finish' : 'Next'}</Button>,
    ];
    return (
      <ReduxDialog
        name={CREATE_JOB_DIALOG}
        title="Create Job"
        actions={actions}
        modal={false}
        autoScrollBodyContent
        fullWidth
        maxWidth="md"
      >
        <div style={styles.form}>
          {/*<Form onSubmit={handleSubmit} style={styles.form}>*/}
          <Stepper activeStep={stepIndex}>
            <Step>
              <StepLabel>Select Customer</StepLabel>
            </Step>
            <Step>
              <StepLabel>Configure Job</StepLabel>
            </Step>
            <Step>
              <StepLabel>Resources</StepLabel>
            </Step>
            {/*<Step>*/}
            {/*<StepLabel>Task Profiles</StepLabel>*/}
            {/*</Step>*/}
            {/*<Step>*/}
            {/*<StepLabel>Preferred Items</StepLabel>*/}
            {/*</Step>*/}
          </Stepper>
          {this.getStepContent(stepIndex)}
          {/*</Form>*/}
        </div>
      </ReduxDialog>
    );
  }
}

CreateJobDialog.propTypes = {
  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
  showWarning: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  // const customers = [{
  //   id: '0',
  //   name: ' -- Add New Customer --',
  // }].concat(state.get('customers').get('customers').toJS() || []).sort((a, b) => sortStrings(a.name, b.name));

  return {
    customers: toJS(state.getIn(['customers', 'customers', 'data'])),
    employees: toJS(state.getIn(['employees', 'employees', 'data'])),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    showDialog,
    hideDialog,
    showWarning,
    submit,
    reset,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateJobDialog);



// WEBPACK FOOTER //
// ./src/components/Jobs/CreateJobDialog/index.js